import { SelectOption } from './interfaces/select-option';
import { SelectOptionGroup } from './interfaces/select-option-group';

export class PdsDynamicSelect {
  is = 'pds-dynamic-select';
  extends = 'select';
  scopeClass: string;

  properties = {
    dynamicOptions: {
      observer: 'optionsUpdated'
    },
    defaultValue: {},
    //Allows the polymer scoping class to propagate into the selects
    scopeClass: String
  };

  //Array of option tags that are going to be there.
  //Everything is in a group, none of them are!
  dynamicOptions: Array<SelectOption> | Array<SelectOptionGroup> = [];

  defaultValue: any;
  defaultUsed = false;

  optionsUpdated(): void {
    let testValue;
    if (this.defaultUsed) {
      testValue = (<any>this).value;
    } else {
      testValue = this.defaultValue;
      this.defaultUsed = true;
    }
    if (testValue == null) {
      testValue = (<any>this).value;
    }

    (<any>this).innerHTML = ''; //clear the previous children.

    // no need to create option elements if the options are not an array
    if (!(this.dynamicOptions instanceof Array)) {
      return;
    }

    this.addOptionsToContainer(this as any as HTMLSelectElement, this.dynamicOptions, testValue);
  }

  private addOptionsToContainer(container: HTMLSelectElement | HTMLOptGroupElement, selectOptions: SelectOption[] | SelectOptionGroup[], testValue: any, selectedOptionFound = false): boolean {
    for (let i = 0; i < selectOptions.length; i++) {
      let option = selectOptions[i];

      let optionEle: HTMLOptionElement | HTMLOptGroupElement;
      if (Array.isArray(option.value)) {
        optionEle = document.createElement('optgroup');
        optionEle.label = option.text;
        selectedOptionFound = this.addOptionsToContainer(optionEle, option.value, testValue, selectedOptionFound);
      } else {
        optionEle = document.createElement('option');
        (optionEle as HTMLOptionElement).value = option.value;
        optionEle.innerText = option.text;

        if ((option as SelectOption).disabled === true) {
          optionEle.setAttribute('disabled', '');
        }

      }

      if (this.scopeClass != null) {
        optionEle.classList.add(this.scopeClass);
      }

      // make sure the first matching option ends up as the selected value
      if (!selectedOptionFound && option.value === testValue) {
        optionEle.setAttribute('selected', '');
        selectedOptionFound = true;
      }

      container.appendChild(optionEle);
    }

    // returns whether or not the currently selected value was found in the list of options
    return selectedOptionFound;
  }
}
